/*
 * MedPraxora - Korrekturen fuer Warenkorb und Mengenauswahl.
 *
 * Drei Aufgaben:
 *
 * 1) MwSt.-Anzeige aktuell halten.
 *    Die Shop-Preise sind netto; Shopify schlaegt die MwSt. erst im Checkout
 *    auf. Liquid rendert die Hinweiszeilen nur beim ersten Seitenaufbau, das
 *    Theme ersetzt danach per AJAX Zeilen und Summen.
 *
 * 2) Mengenfeld mit dem echten Warenkorb synchronisieren.
 *    Das Theme (assets/jquery.interact-function.js) rechnet den Feldwert nur
 *    im Browser hoch und schreibt die Server-Antwort nie zurueck. Ergebnis:
 *    Das Feld zeigt eine andere Menge als der Warenkorb enthaelt.
 *
 * 3) Mengengrenze 200 Stueck pro Position, darueber "auf Anfrage".
 *    Die Bestandsverfolgung ist aus (Handelsware ohne eigenes Lager), also
 *    gibt es keine natuerliche Obergrenze mehr. Die Grenze steht hier:
 */
(function () {
  'use strict';

  var MAX_PRO_POSITION = 200;
  var ANFRAGE_URL = '/pages/contact';

  if (window.__medpraxoraCart) return;
  window.__medpraxoraCart = true;

  var block = null;
  var rate = 19;
  var observer = null;
  var debounce = null;
  var painting = false;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function tax(net) {
    return Math.round((net * rate) / 100);
  }

  function note(parent, cls, html) {
    var el = parent.querySelector('.' + cls);
    if (!el) {
      el = document.createElement('div');
      el.className = cls;
      parent.appendChild(el);
    }
    if (el.innerHTML !== html) el.innerHTML = html;
    return el;
  }

  function setValue(selector, text) {
    var el = block && block.querySelector(selector);
    if (el && el.textContent !== text) el.textContent = text;
  }

  /*
   * Das Theme liest die Obergrenze aus data-max und zwar erst beim Klick.
   * Wir setzen sie vorher, damit die Sperre bei 200 greift. Ohne Bestands-
   * verfolgung rendert Liquid dort 0, was das Theme als "kein Limit" liest.
   */
  function applyLimit() {
    var fields = document.querySelectorAll('.js_qty');
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].getAttribute('data-max') !== String(MAX_PRO_POSITION)) {
        fields[i].setAttribute('data-max', MAX_PRO_POSITION);
      }
      if (window.jQuery) window.jQuery(fields[i]).data('max', MAX_PRO_POSITION);
    }
  }

  function limitHint(container, quantity) {
    var existing = container.querySelector('.mengen-hinweis');
    if (quantity >= MAX_PRO_POSITION) {
      note(
        container,
        'mengen-hinweis',
        'Maximal ' + MAX_PRO_POSITION + ' Stück pro Position. ' +
          'Größere Mengen gerne <a href="' + ANFRAGE_URL + '">auf Anfrage</a>.'
      );
    } else if (existing) {
      existing.parentNode.removeChild(existing);
    }
  }

  /*
   * Schreibt die tatsaechliche Menge aus dem Warenkorb zurueck ins Feld.
   * Das Theme rendert nullpaddiert (01, 02) - hier dasselbe Format, sonst
   * flackert das Feld bei jedem Abgleich.
   */
  function syncQuantities(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var wanted = item.quantity < 10 ? '0' + item.quantity : String(item.quantity);
      var fields = document.querySelectorAll(
        '#updates_' + item.id + ', .js_qty[data-product-id="' + item.id + '"]'
      );
      for (var j = 0; j < fields.length; j++) {
        if (document.activeElement === fields[j]) continue;
        if (fields[j].value !== wanted) fields[j].value = wanted;
      }
    }
  }

  function paint(cart) {
    painting = true;
    if (observer) observer.disconnect();

    try {
      syncQuantities(cart);
      applyLimit();

      var rows = document.querySelectorAll('.shopping-cart-content tr.product-item');
      for (var i = 0; i < rows.length; i++) {
        var item = cart.items[i];
        if (!item) continue;

        var priceBox = rows[i].querySelector('.price');
        if (priceBox) {
          var unit = item.final_price;
          note(priceBox, 'cart_price_tax', 'zzgl. MwSt. &middot; ' + money(unit + tax(unit)) + ' inkl. MwSt.');
        }

        var totalCell = rows[i].querySelector('td.total');
        if (totalCell) {
          var line = item.final_line_price;
          note(totalCell, 'cart_price_tax', money(line + tax(line)) + ' inkl. MwSt.');
        }

        var qtyCell = rows[i].querySelector('.quantity-item');
        if (qtyCell) limitHint(qtyCell, item.quantity);
      }

      if (block) {
        var net = cart.total_price;
        var vat = tax(net);
        setValue('.info-mwst-netto .item', money(net));
        setValue('.info-mwst-betrag .item', money(vat));
        setValue('.info-mwst-brutto .item', money(net + vat));
      }
    } catch (e) {
      /* Die Anzeige darf den Warenkorb nie blockieren. */
    } finally {
      painting = false;
      if (observer) {
        observer.takeRecords();
        connect();
      }
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {});
  }

  function schedule() {
    if (painting) return;
    clearTimeout(debounce);
    debounce = setTimeout(refresh, 150);
  }

  function connect() {
    var targets = [
      document.querySelector('.shopping-cart-content'),
      document.querySelector('.cart-total')
    ];
    for (var i = 0; i < targets.length; i++) {
      if (targets[i]) {
        observer.observe(targets[i], { childList: true, subtree: true, characterData: true });
      }
    }
  }

  function init() {
    applyLimit();

    block = document.querySelector('.mwst-block');

    if (block) {
      var declared = parseFloat(block.getAttribute('data-mwst-rate'));
      if (!isNaN(declared) && declared > 0) rate = declared;

      // Summenblock direkt unter die Zwischensumme schieben, damit die Betraege
      // zusammenhaengend stehen und nicht hinter eingeschobenen App-Bloecken.
      var subtotal = document.querySelector('.cart-total .info-subtotal');
      if (subtotal && subtotal.parentNode && subtotal.nextSibling !== block) {
        subtotal.parentNode.insertBefore(block, subtotal.nextSibling);
      }
    }

    // Auf der Produktseite gibt es keinen Warenkorb zum Abgleichen, aber die
    // Mengengrenze muss trotzdem gelten.
    if (!document.querySelector('.shopping-cart-content')) {
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.js_plus, .js_minus')) {
          setTimeout(applyLimit, 50);
        }
      });
      return;
    }

    observer = new MutationObserver(schedule);
    connect();

    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      if (el.closest('.js_plus, .js_minus, .js-remove-item, .clear-cart')) {
        setTimeout(refresh, 450);
        setTimeout(refresh, 1200);
        setTimeout(refresh, 2500);
      }
    });
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el && el.closest && el.closest('.js_qty')) {
        setTimeout(refresh, 450);
        setTimeout(refresh, 1400);
      }
    });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
